import { render } from "./ABtn.vue?vue&type=template&id=7f86e5f7&scoped=true"
import script from "./ABtn.vue?vue&type=script&lang=js"
export * from "./ABtn.vue?vue&type=script&lang=js"

import "./ABtn.vue?vue&type=style&index=0&id=7f86e5f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f86e5f7"]])

export default __exports__